<script setup lang="ts">
import { computed } from 'vue'
import InfoTriangle from '@/assets/images/ide/info-triangle.svg?component'
import { useAuthStore } from '@/stores/auth.store'
import { useOrganisationStore } from '@/stores/organisation.store'

const organisationStore = useOrganisationStore()

/**
 * Owner does not include Admin, Teacher, or Student role
 */
const isOwner = computed(() => organisationStore.isOrganisationOwner)

const authStore = useAuthStore()

const projectLimit = computed(() => authStore.projectLimit!.limit)
</script>

<template>
  <div
    class="m-1 flex items-center gap-x-3 rounded border border-error-300 bg-error-50 px-2 py-1 dark:border-error-600 dark:bg-error-500/50"
  >
    <div class="self-start">
      <InfoTriangle class="w-6 shrink-0 text-error-400 dark:text-error-500" />
    </div>
    <p class="text-sm">
      <span class="font-semibold"
        >You have reached the limit of {{ projectLimit }} free projects.</span
      >
      Your existing projects will be <span class="font-semibold">read-only</span>. Delete existing
      projects to create new ones or <span v-if="isOwner">enjoy unlimited projects with a</span>
      <router-link v-if="isOwner" :to="{ path: 'pricing' }" class="font-semibold underline">
        plan upgrade.
      </router-link>
      <span v-else class="font-semibold underline">contact your admin</span>
      <span v-if="!isOwner"> to enjoy unlimited projects</span>
    </p>
  </div>
</template>
